import {usePathname} from '@aboutyou/router';
import {HubPageTypes} from '../types';

export const useHubTypeFromSlug = () => {
  const pathname = usePathname();
  const splitPathname = pathname.split('/');
  const hubType = splitPathname[splitPathname.length - 1];
  return hubType as HubPageTypes;
};
